import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

/**
 * Update region
 *
 * @private
 */
export const addTrafficProfile = createAsyncThunk<
  // Return type of the payload creator
  string,
  // First argument to the payload creator
  uui.domain.rm.Recurrence,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/traffic/addTrafficProfile', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()
    const response = await rpc('rpc/traffic/addTrafficProfile', {
      category: 'rpc',
      type: 'rpc/traffic/addTrafficProfile',
      recurrence: payload,
    })
    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }

    return response.result
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {addTrafficProfile}`,
      { tags: ['rpc', 'traffic'], info: payload },
      'error',
    )
    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Update time windows failed`,
      error,
    })
  }
})
